import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './SubscriptionPopups.css';

/**
 * SubModal — shared shell for every subscription popup.
 * Controlled entirely by the `show` prop (no data-bs-toggle,
 * no Bootstrap JS bundle required — only Bootstrap's CSS,
 * which the app already loads).
 *
 * Props:
 *  - show       {bool}      whether the modal is visible
 *  - onClose    {function}  called on backdrop click / X button.
 *                           Omit (or pass null) for blocking modals
 *                           that shouldn't be dismissible.
 *  - contentClassName {string} extra class on modal-content (e.g. left-aligned layout)
 *  - children   modal body content
 */
const SubModal = ({ show, onClose, contentClassName = '', children }) => {

  // Lock page scroll while a modal is open
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    }
    return () => { document.body.style.overflow = ''; };
  }, [show]);

  if (!show) return null;

  const dismissible = typeof onClose === 'function';

  return (
    <>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        onClick={dismissible ? onClose : undefined}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`modal-content sub-modal-content ${contentClassName}`}>
            {dismissible && (
              <button
                type="button"
                className="sub-modal-close"
                aria-label="Close"
                onClick={onClose}
              >
                <X size={16} />
              </button>
            )}
            {children}
          </div>
        </div>
      </div>
      <div className="fade show sub-modal-backdrop"></div>
    </>
  );
};

export default SubModal;
